import React from "react"
import { Check, ShieldCheck, Rocket } from "lucide-react"
import { AboutData } from "../types/objects"
import { SectionHeading } from "./ui/SectionHeading"

/**
 * Props interface for About component
 */
interface AboutProps {
	data?: AboutData
}

/**
 * About Component — company intro with an illustrated brand card and a checklist of reasons.
 */
export const About: React.FC<AboutProps> = ({ data }) => {
	const reasons = data ? [...data.Why, ...data.Why2] : []

	return (
		<section id="about" className="lp-section">
			<div className="lp-container">
				<div className="lp-about">
					{/* Left column: illustrative image with floating fact badges */}
					<div className="lp-about__media" data-reveal="left">
						<img
							src="img/about2.jpg"
							className="lp-about__img"
							alt="O nás - ilustrační obrázek"
							loading="lazy"
						/>
						<div className="lp-about__badge lp-about__badge--1">
							<span className="lp-icon-badge" style={{ width: 40, height: 40, borderRadius: 12 }} aria-hidden="true">
								<Rocket size={18} />
							</span>
							<div>
								<strong>Druhým rokem na trhu</strong>
								<span>mladá firma, tempo většího týmu</span>
							</div>
						</div>
						<div className="lp-about__badge lp-about__badge--2">
							<span className="lp-icon-badge lp-icon-badge--soft" style={{ width: 40, height: 40, borderRadius: 12 }} aria-hidden="true">
								<ShieldCheck size={18} />
							</span>
							<div>
								<strong>Záruka 6 měsíců</strong>
								<span>reakce na incident do 4 h</span>
							</div>
						</div>
					</div>

					{/* Right column: text content */}
					<div className="lp-about__text" data-reveal="right">
						<SectionHeading
							eyebrow="Kdo jsme"
							title="O nás"
							center={false}
						/>

						<p>{data ? data.paragraph : "Načítám informace..."}</p>

						<h3 className="lp-about__sub">Proč si nás vybrat?</h3>

						<ul className="lp-checks">
							{reasons.length > 0 ? (
								reasons.map((item, index) => (
									<li
										className="lp-check"
										key={`why-${index}`}
										data-reveal=""
										style={{ "--reveal-delay": `${index * 60}ms` } as React.CSSProperties}
									>
										<span className="lp-check__icon" aria-hidden="true">
											<Check size={14} strokeWidth={3} />
										</span>
										<span>{item}</span>
									</li>
								))
							) : (
								<li>Načítám...</li>
							)}
						</ul>
					</div>
				</div>
			</div>
		</section>
	)
}
